import { Component, OnInit } from '@angular/core';
import { NgxSmartModalComponent, NgxSmartModalService } from '@bssh/comp-lib';
import { BaseModalComponent } from '../base-modal/base-modal.component';
import { IModalInput, IModalOutput } from '../model/action-modal';

export interface ValidationWarningItem {
  fieldLabel?: string;
  message: string;
}

export interface IValidationWarningsModalInput extends IModalInput {
  title?: string;
  subTitle?: string;
  /** Summary line shown above the list, without an icon. */
  headerMessage?: string;
  warnings: ValidationWarningItem[];
  confirmButtonText?: string;
  closeButtonText?: string;
  /** Errors are blocking, so the modal is opened without a confirm button in that case. */
  severity?: 'warning' | 'error';
  showConfirmButton?: boolean;
}

export interface IValidationWarningsModalOutput extends IModalOutput {
  isProceed: boolean;
}

@Component({
  selector: 'app-validation-warnings-modal',
  templateUrl: './validation-warnings-modal.component.html',
  styleUrls: ['./validation-warnings-modal.component.scss']
})
export class ValidationWarningsModalComponent extends BaseModalComponent implements OnInit {
  modalType = 'validationWarningsModal';
  title = 'Validation Warnings';
  subTitle = '';
  headerMessage = '';
  warnings: ValidationWarningItem[] = [];
  confirmText = 'Yes, proceed';
  closeText = 'No, stay on this page';
  severity: 'warning' | 'error' = 'warning';
  isProceed = false;

  constructor(
    public ngxSmartModalService: NgxSmartModalService
  ) {
    super(ngxSmartModalService);
  }

  ngOnInit() {
    super.ngOnInit();

    this.subs.sink = this.data.subscribe((modalInput: IValidationWarningsModalInput) => {
      if (modalInput) {
        this.title = modalInput.title || this.title;
        this.subTitle = modalInput.subTitle || this.subTitle;
        this.headerMessage = modalInput.headerMessage || this.headerMessage;
        this.warnings = modalInput.warnings || [];
        this.confirmText = modalInput.confirmButtonText || this.confirmText;
        this.closeText = modalInput.closeButtonText || this.closeText;
        this.severity = modalInput.severity || this.severity;
        this.showConfirmButton = modalInput.showConfirmButton !== false;
      }
    });
  }

  close(modal: NgxSmartModalComponent): void {
    const output: IValidationWarningsModalOutput = { isProceed: this.isProceed };
    this.confirm.emit(output);
    this.confirm.complete();
    super.close(modal);
  }

  accept(modal: NgxSmartModalComponent) {
    this.isProceed = true;
    modal.close();
  }
}
